import React, { createContext, useState } from "react";

export const FormContext = createContext();

export function FormProvider({ children }) {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    amount: "",
    currency: "USD",
    telegram: "",
    passportFront: null,
    passportBack: null,
    selfie: null,
  });

  const [currentStep, setCurrentStep] = useState(1);
  const [currentPage, setCurrentPage] = useState("contact");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const updateFormData = (newData) => {
    setFormData((prev) => ({ ...prev, ...newData }));
  };

  const goToStep = (step) => setCurrentStep(step);
  const goToPage = (page) => setCurrentPage(page);

  const submitForm = async () => {
    try {
      setLoading(true);
      const formDataMultipart = new FormData();
      formDataMultipart.append("fullName", formData.name);
      formDataMultipart.append("email", formData.email);

      if (formData.passportFront)
        formDataMultipart.append("passport_front", formData.passportFront);
      if (formData.passportBack)
        formDataMultipart.append("passport_back", formData.passportBack);
      if (formData.selfie)
        formDataMultipart.append("selfie", formData.selfie);

      const response = await fetch("https://bilpay.kg/api/kyc", {
        method: "POST",
        body: formDataMultipart,
      });

      const data = await response.json();

      if (data.success) {
        setMessage("✅ Данные успешно отправлены!");
        setFormData({
          name: "",
          email: "",
          amount: "",
          currency: "USD",
          telegram: "",
          passportFront: null,
          passportBack: null,
          selfie: null,
        });
        setCurrentStep(1);
      } else {
        setMessage(`❌ Ошибка: ${data.error}`);
      }
    } catch (err) {
      console.error(err);
      setMessage("❌ Ошибка отправки данных");
    } finally {
      setLoading(false);
    }
  };

  return (
    <FormContext.Provider
      value={{
        formData,
        updateFormData,
        currentStep,
        goToStep,
        currentPage,
        goToPage,
        submitForm,
        loading,
        message,
        setMessage,
      }}
    >
      {children}
    </FormContext.Provider>
  );
}
